import styles from './RepaymentSummaryItem.module.css';

const RepayLabel = (props) => {
    const { children } = props;
    return <div className={styles.RepayLabel}>{children}</div>;
};

// eslint-disable-next-line import/no-default-export
export default RepayLabel;
